import { backgroundDrawer } from '../../elementDrawers/background/BackgroundDrawer';
import { DragonBitingAnimation, DragonSoulAnimations, LeafAnimations, WallAnimations } from '../../core/enums';
import { TimelineLite } from 'gsap';

class GameAnimationService {
  constructor(drawer) {
    this.drawer = drawer;
  }

  click(texture, duration = 0.1, scales = [0.9, 1]) {
    return new TimelineLite()
      .to(texture, { duration, pixi: { scale: scales[0] } })
      .to(texture, { duration, pixi: { scale: scales[1] } });
  }

  get animations() {
    return this.drawer.background.application.__animations;
  }

  get bgContainer() {
    return this.drawer.background.application.container;
  }

  bonusBall(events, loop) {
    return this.animations[DragonBitingAnimation.bonusBall](events, loop);
  }

  breakBall(events, loop) {
    return this.animations[DragonBitingAnimation.break](events, loop);
  }

  crackBall(events, loop) {
    return this.animations[DragonBitingAnimation.crack](events, loop);
  }

  dragonSoulLoop(events, loop) {
    return this.animations[DragonSoulAnimations.loop](events, loop);
  }

  dragonSoulDracarys(events, loop) {
    return this.animations[DragonSoulAnimations.dracarys](events, loop);
  }


  dragonSoulAppear(events, loop) {
    return this.animations[DragonSoulAnimations.appear](events, loop);
  }

  dragonSoulAppearAndLoop() {
    return this.dragonSoulAppear().then(() => {
      this.dragonSoulLoop({}, true);
    });
  }

  leafAnimation(events, loop) {
    return this.animations[LeafAnimations.animation](events, loop);
  }

  breakBallBoom(events, loop) {
    return this.animations.breakBallBoom(events, loop);
  }

  crackParticles(events, loop) {
    return this.animations.crackParticles(events, loop);
  }

  breakCustomBallBoom(index, events, loop) {
    return this.animations.breakCustomBallBoom(index, events, loop);
  }

  wallLight(events, loop) {
    return this.animations[WallAnimations.wallLight](events, loop);
  }
}

export const gameAnimations = new GameAnimationService({
  background: backgroundDrawer,
});
